import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

interface Translation {
  translation_key: string;
  translation_value: string;
}

export function useOnboardingTranslations(locale: string = 'en-US') {
  const [translations, setTranslations] = useState<Record<string, string>>({});
  const [loading, setLoading] = useState(true);
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const fetchTranslations = async () => {
      try {
        const customerId = searchParams.get('customer');
        
        console.log('🌍 useOnboardingTranslations - Starting fetch with:', { customerId, locale });
        
        if (!customerId) {
          console.warn('🌍 No customer ID found in URL parameters');
          setLoading(false);
          return;
        }

        // Use the new public translations endpoint
        const url = new URL('https://zsbvxxdmhewaxkbkqgga.supabase.co/functions/v1/customer-onboarding-translations');
        url.searchParams.append('customer_id', customerId);
        url.searchParams.append('document_type', 'onboarding');
        url.searchParams.append('locale', locale);

        console.log('🌍 Making translations request to:', url.toString());

        const response = await fetch(url.toString(), {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json'
          }
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        console.log('🌍 Translations response received:', data);

        const translationMap: Record<string, string> = {};
        data?.data?.forEach((t: Translation) => {
          translationMap[t.translation_key] = t.translation_value;
        });

        console.log('🌍 Translation map created:', translationMap);
        console.log('🌍 Number of translations loaded:', Object.keys(translationMap).length);
        
        setTranslations(translationMap);
      } catch (error) {
        console.error('🌍 Error fetching translations:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchTranslations();
  }, [locale, searchParams]);

  const t = (key: string, fallback?: string) => {
    const result = translations[key] || fallback || key;
    console.log(`🌍 Translation lookup - key: "${key}", found: "${translations[key] || 'NOT_FOUND'}", result: "${result}"`);
    return result;
  };

  return { t, loading, translations };
}